import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "../Style/Footer.css";

import {
    MDBFooter,
    MDBContainer,
    MDBBtn,
    MDBIcon
} from 'mdb-react-ui-kit';

export const Footer: React.FC = () => {
    return (
        <MDBFooter className="footer">
            {/* <MDBContainer className="container">
                <section className="social-buttons">
                    <MDBBtn
                        floating
                        className="social-btn"
                        style={{ backgroundColor: '#3b5998' }}
                        href="#!"
                        role="button"
                        noRipple={true} // Disable ripple effect
                    >
                        <MDBIcon fab icon="facebook-f" />
                    </MDBBtn>

                    <MDBBtn
                        floating
                        className="social-btn"
                        style={{ backgroundColor: '#55acee' }}
                        href="#!"
                        role="button"
                        noRipple={true} // Disable ripple effect
                    >
                        <MDBIcon fab icon="twitter" />
                    </MDBBtn>

                    <MDBBtn
                        floating
                        className="social-btn"
                        style={{ backgroundColor: '#dd4b39' }}
                        href="#!"
                        role="button"
                        noRipple={true} // Disable ripple effect
                    >
                        <MDBIcon fab icon="google" />
                    </MDBBtn>

                    <MDBBtn
                        floating
                        className="social-btn"
                        style={{ backgroundColor: '#ac2bac' }}
                        href="#!"
                        role="button"
                        noRipple={true} // Disable ripple effect
                    >
                        <MDBIcon fab icon="instagram" />
                    </MDBBtn>

                    <MDBBtn
                        floating
                        className="social-btn"
                        style={{ backgroundColor: '#0082ca' }}
                        href="#!"
                        role="button"
                        noRipple={true} // Disable ripple effect
                    >
                        <MDBIcon fab icon="linkedin-in" />
                    </MDBBtn>

                    <MDBBtn
                        floating
                        className="social-btn"
                        style={{ backgroundColor: '#333333' }}
                        href="#!"
                        role="button"
                        noRipple={true} // Disable ripple effect
                    >
                        <MDBIcon fab icon="github" />
                    </MDBBtn>
                </section>
            </MDBContainer> */}

            <div className="copyright">
                © 2026 Copyright:
                <a href="https://www.linkedin.com/in/lalmuni-singh/"> PanAcco.com</a>
            </div>
        </MDBFooter>
    );
};

export default Footer;
